import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Save } from "lucide-react";

export function AdminSettings() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/site-settings").then((r) => setS(r.data)); }, []);
  if (!s) return <div>Loading…</div>;
  const up = (k, v) => setS({ ...s, [k]: v });
  const save = async () => {
    try { await api.put("/site-settings", s); toast.success("Settings saved"); } catch (e) { toast.error(formatApiError(e)); }
  };
  return (
    <div data-testid="page-admin-settings" className="max-w-3xl">
      <div className="text-[10px] uppercase tracking-[0.28em] text-[#7A736C] mb-2">Global</div>
      <h1 className="font-serif text-4xl tracking-tight mb-8">Site settings</h1>
      <div className="bg-white border border-[#D5D0C8] p-8 rounded-sm space-y-4 text-sm">
        {[
          ["business_name", "Business name"], ["tagline", "Tagline"], ["description", "Description", "textarea"],
          ["email", "Contact email"], ["phone", "Phone"], ["whatsapp", "WhatsApp number"], ["address", "Address", "textarea"],
          ["instagram", "Instagram URL"], ["facebook", "Facebook URL"], ["pinterest", "Pinterest URL"], ["linkedin", "LinkedIn URL"],
          ["logo", "Logo URL"], ["favicon", "Favicon URL"], ["primary_color", "Primary color (hex)"],
          ["google_maps_embed", "Google Maps embed URL"], ["analytics_id", "Google Analytics ID"], ["meta_pixel_id", "Meta Pixel ID"],
        ].map(([k, label, type]) => (
          <label key={k} className="block"><span className="block text-[10px] uppercase tracking-[0.28em] text-[#7A736C] mb-1">{label}</span>
            {type === "textarea"
              ? <textarea rows={3} value={s[k] || ""} onChange={(e) => up(k, e.target.value)} className="input" data-testid={`settings-${k}`} />
              : <input value={s[k] || ""} onChange={(e) => up(k, e.target.value)} className="input" data-testid={`settings-${k}`} />}
          </label>
        ))}
        <label className="block"><span className="block text-[10px] uppercase tracking-[0.28em] text-[#7A736C] mb-1">Service areas (comma)</span>
          <input value={(s.service_areas || []).join(", ")} onChange={(e) => up("service_areas", e.target.value.split(",").map((x) => x.trim()).filter(Boolean))} className="input" data-testid="settings-service-areas" />
        </label>
      </div>
      <button onClick={save} data-testid="settings-save" className="mt-6 inline-flex items-center gap-2 px-6 py-3 bg-[#A85C42] text-white text-xs uppercase tracking-[0.2em] rounded-sm hover:bg-[#2B2927]"><Save size={14} /> Save settings</button>
      <style>{`.input{background:white;border:1px solid #D5D0C8;padding:8px 10px;width:100%;font-size:13px;border-radius:3px;outline:none}.input:focus{border-color:#A85C42}`}</style>
    </div>
  );
}
